<div
  class="fixed left-0 right-0 max-h-85-screen overflow-y-auto rounded-t-3xl bg-white shadow-up-L"
  [style.z-index]="((index$ | async) ?? 0) + 50"
  [style.bottom.px]="keyboardOffset"
  [class.bottom-0]="keyboardOffset === 0"
>
  @if (textWithButtonItem) {
    <app-push-modal-button-atom
      [text]="textWithButtonItem.text ?? ''"
      [title]="textWithButtonItem.title"
      [imgUrl]="textWithButtonItem.img ?? ''"
      [isSafari]="isSafari"
      (yesButtonClick)="installPwa()"
      (noButtonClick)="close()"
    ></app-push-modal-button-atom>
  }
</div>
